export interface Brands {
  brandId: string;
  name: string;
}

export interface BrandContent {
  [BrandAssetName.FONTS]: BrandContentData;
  [BrandAssetName.LOGOS]: BrandContentData;
  [BrandAssetName.COLORS]: BrandContentData;
}

export enum BrandsLoadingState {
  NOT_LOADED = 1,
  LOADING = 2,
  LOADED = 3,
}

export interface BrandContentData {
  loaded: number;
  ids: Array<number>;
}

export enum BrandAssetName {
  FONTS = 'fonts',
  COLORS = 'colors',
  LOGOS = 'logos',
}

export enum BrandAsset {
  LOGOS = 1,
  COLORS = 2,
  FONTS = 3,
}

export interface BrandLogo {
  id: number;
  filename: string;
  ext: string;
  uploaderName: string;
  uploaderId: string;
  hasTransparency: boolean;
  src: string;
  width: number;
  height: number;
}

export interface BrandFont {
  idbrandFont: number;
  fontFamily: string;
}

export interface BrandColor {
  idbrandColor: number;
  hexCode: string;
}

export enum BRANDS_ANALYTICS_EVENT_NAMES {
  USE_FONT = 'BrandKits_UseFont',
  USE_COLOR = 'BrandKits_UseColor',
  USE_LOGO = 'BrandKits_UseLogo',
}
